import React, { Component } from 'react';
import { Divider, message } from 'antd';
import { getParam } from 'ruigu-utils';
import './login.styl';
import IconWelcome from '@/assets/images/welcome.png';
import IconCSLoginBg from '@/assets/images/login/cs-login-bg.png';
import IconLoginTitle from '@/assets/images/loginTitle.png';
import IconCSTitle from '@/assets/images/login/cs-logo.png';
import SweepLogin from '@/components/SweepLogin/SweepLogin';
import AccountLogin from '@/components/AccountLogin/AccountLogin';
import PhoneLogin from '@/components/PhoneLogin/PhoneLogin';
import { onExit, hrefHomeByToken, checkIsLaunchpad, isSafeReturnURL } from '@/utils/util';
import { checkToken } from '@/api/login';
import store from 'store';

export default class Login extends Component {
  state = {
    checkIndex: 0,
    propsKeyDownNum: null,
    themeCss: '',
    system: '',
  };

  async init() {
    // 拦截test环境使用https重定向到http
    if (window.location.href.startsWith('https://test.')) {
      message.warning('test环境请使用http，不要使用https');
      return;
    }

    // 记录是否来源第三方url授权页面
    const returnURL = getParam('returnURL');
    const returnFullURL = window.location.search.replace('?returnURL=', '');
    if (returnURL && isSafeReturnURL(returnFullURL)) {
      window.sessionStorage.setItem('returnURL', returnFullURL);
      // const token = localStorage.getItem('token');
      // if (token) {
      //   handleCheckToken(JSON.parse(token))
      // }
      this.setState({
        themeCss: `theme-${getParam('system')}`,
        system: getParam('system'),
      });
    } else {
      window.sessionStorage.removeItem('returnURL');
      // 清除状态值
      // onExit();
    }

    this.checkEntry();
  }

  checkEntry = async () => {
    const { bizOrgList, userInfo } = store.get('iframeUser') || {};
    const token = store.get('token');
    if (token) {
      await checkToken(token);
      hrefHomeByToken(token, bizOrgList, userInfo, this.props.history);
    }
  };

  componentDidMount() {
    this.init();

    // 监听用户敲击键盘回车
    window.addEventListener('keydown', (e) => {
      if (e.keyCode && e.keyCode === 13) {
        this.setState({
          propsKeyDownNum: Math.random() * 1e18
        })
      }
    })
  }

  render() {
    const { checkIndex, propsKeyDownNum, themeCss, system } = this.state;
    const isReturnURL =
      getParam('returnURL') || window.sessionStorage.getItem('returnURL');
    return (
      <div className={`login flex-col-center-center ${themeCss}`}>
        {/* <div className="logo-wrapper">
          <img alt="logo" className="logo" src={Logo} />
          // Welcome
        </div>
        <h1 className="title fs-28">锐锢中台</h1> */}
        <div className="cot-box flex-row-center-center">
          {!themeCss ? (
            <img alt="logo" className="welcome" src={IconWelcome} />
          ) : ''}
          {themeCss === 'theme-cs' ? (
            <img alt="logo" className="theme-cs-welcome" src={IconCSLoginBg} />
          ) : ''}

          <div className="login-box">
            {!themeCss ? (
              <img alt="logo" className="title fs-28 center" src={IconLoginTitle} />
            ) : ''}
            {themeCss === 'theme-cs' ? (
              <img alt="logo" className="title theme-cs-title fs-28 center" src={IconCSTitle} />
            ) : ''}
            <div className={`login-mode flex-row-between-center ${isReturnURL ? '' : 'login-mode-padding'}`}>
              <span
                className={checkIndex === 0 ? 'selected pointer' : 'pointer'}
                onClick={() => this.handleCheckIndex(0)}
              >
                密码登录
              </span>
              <Divider type="vertical" />
              <span
                className={checkIndex === 1 ? 'selected pointer' : 'pointer'}
                onClick={() => this.handleCheckIndex(1)}
              >
                短信登录
              </span>
              {checkIsLaunchpad() ? (
                <>
                  <Divider type="vertical" />
                  <span
                    className={checkIndex === 2 ? 'selected pointer' : 'pointer'}
                    onClick={() => this.handleCheckIndex(2)}
                  >
                    扫码登录
                  </span>
                </>
              ) : ''}
              {/* {isReturnURL && system != 'cs' ? (
                <>
                  <Divider type="vertical" />
                  <span className="pointer" onClick={this.handleThirLogin}>
                    三方登录
                  </span>
                </>
              ) : ''} */}
            </div>
            <div className="login-container">
              <div
                className={`flex-row-start-start m-t-20`}
                style={{
                  transform: `translateX(${-390 * checkIndex}px)`,
                  transition: `transform .2s linear`,
                }}
              >
                <AccountLogin checkIndex={checkIndex} propsKeyDownNum={checkIndex === 0 ? propsKeyDownNum : null} />
                <PhoneLogin checkIndex={checkIndex} propsKeyDownNum={checkIndex === 1 ? propsKeyDownNum : null} />
                {checkIsLaunchpad() ? (
                  <SweepLogin checkIndex={checkIndex} />
                ) : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleCheckIndex = (checkIndex) => {
    this.setState({
      checkIndex,
      propsKeyDownNum: null,
    });
  };

  handleThirLogin = () => {
    // 校验是否来源第三方url授权页面
    const returnURL =
      getParam('returnURL') || window.sessionStorage.getItem('returnURL');
    const returnFullURL = window.location.search.replace('?returnURL=', '');
    if (returnURL && isSafeReturnURL(returnFullURL)) {
      window.sessionStorage.removeItem('returnURL');
      const splitArr = returnFullURL.split('?');
      window.location.replace(
        `${splitArr[0]}?openLogin=1${splitArr[1] ? '&' + splitArr[1] : ''}`,
      );
    } else {
      message.warning('请从三方项目进入登录');
    }
  };
}
